<template> <!--  邮局派送 -->
  <div class="mb10">
    <div class="feet-r mb10">
      <!-- 增加一行 -->
      <el-button
        size="small"
        type="primary"
        @click="handleAdd"
      >{{ $t('basicData.AddARow') }}</el-button>

      <!-- 下载/导入 -->
      <importAndDowloadCmp
        :partition-id="partitionId"
        :subregion-list="subregionList"
        :fee-type-list="feeTypeList"
        :get-data-func="onDownloadOffer"
        @importList="onImportList"
      />

      <!-- 清空报价 -->
      <el-popover
        placement="bottom-start"
        trigger="hover"
      >
        <div class="feet">
          <!--清空当前分区-->
          <el-button
            size="small"
            type="primary"
            @click="onClear"
          >{{ $t('basicData.EmptyCurrentPartition') }}
          </el-button>
          <!--清空所有分区-->
          <el-button
            class="feet-btn"
            size="small"
            type="primary"
            @click="onAllClear"
          >{{ $t('basicData.EmptyAllPartitions') }}
          </el-button>
        </div>
        <!--清空报价-->
        <el-button
          slot="reference"
          size="small"
        >{{ $t('basicData.ClearTheOffer') }}</el-button>
      </el-popover>
    </div>

    <!--没有选择分区 -->
    <TableCmp
      v-if="!partitionId"
      ref="defaultTableRef"
      :fee-type-list="feeTypeList"
      :table-data="defaultPartitionObj.default.arr"
      @change="arr => defaultPartitionObj.default.arr = arr"
    />

    <!--选择了分区 -->
    <TableCmp
      v-if="partitionId && subregionList.length > 0"
      ref="tableRef"
      :fee-type-list="feeTypeList"
      :table-data="getPartitionArr"
      @change="changePartition"
    />

    <!--     特殊规则-->
    <el-divider content-position="left">{{ $t('receivablePayable.specialRules') }}</el-divider>
    <!--没有选择分区 -->
    <TableCmpOther
      v-if="!partitionId"
      :fee-type-list="feeTypeList"
      :table-data="defaultPartitionObj.default.otherArr"
      @change="arr => defaultPartitionObj.default.otherArr = arr"
    />

    <!--选择了分区 -->
    <TableCmpOther
      v-if="partitionId && subregionList.length > 0"
      :fee-type-list="feeTypeList"
      :table-data="getPartitionOtherArr"
      @change="changePartitionOther"
    />
  </div>
</template>

<script>
import TableCmp from './TableCmp.vue';
import TableCmpOther from './TableCmpOther.vue';
import importAndDowloadCmp from './importAndDowloadCmp.vue';
import { TMP_OBJ, SEPARATOR, notSetPartitionFun, setPartitionFun } from './utils';
import { cloneDeep } from 'lodash-es';

const otherArr = [
  {
    id: '',
    type: 1,
    partitionAffiliateId: '',
    overWeightExtraPrice: '',
    overWeight: '',
    feeTypeCode: ''
  },
  {
    id: '',
    type: 2,
    partitionAffiliateId: '',
    overSizeExtraPrice: '',
    overSize: '',
    feeTypeCode: ''
  }
];

export default {
  name: '',

  components: {
    TableCmp,
    importAndDowloadCmp,
    TableCmpOther
  },

  props: {
    // 分区
    partitionId: {
      type: [Number, String],
      default: () => {
        return 0;
      }
    },

    // 分区id
    partitionAffiliateId: {
      type: [String, Number],
      default: ''
    },

    // 所有分区
    subregionList: {
      type: Array,
      default: () => {
        return [];
      }
    },

    feeTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },

  data() {
    return {
      // partitionAffiliateId: '', // 选中的分区id

      // 如果没有选择分区-普通规则
      defaultPartitionObj: {
        default: {
          arr: [],
          otherArr: otherArr
        }
      },

      /** @type {TTableObj}
       * @desc 如果选择了分区
       */
      partitionObj: {
        // 分区id1: { arr: []， otherArr: [] },
        // 分区id2: { arr: [], otherArr: [] },
      }
    };
  },

  computed: {
    partitionComputed() {
      const a = this.partitionId;// 分区
      const b = this.subregionList;// 所有子分区
      return {
        a, b
      };
    },

    // 普通规则-获取当前分区的数据
    getPartitionArr() {
      const row = this.partitionObj[this.partitionAffiliateId];
      if (this.partitionAffiliateId && row && row.arr) {
        return this.partitionObj[this.partitionAffiliateId].arr || [];
      }
      return [];
    },

    // 特殊规则-获取当前分区的数据
    getPartitionOtherArr() {
      const row = this.partitionObj[this.partitionAffiliateId];
      if (this.partitionAffiliateId && row && row.otherArr) {
        return this.partitionObj[this.partitionAffiliateId].otherArr || [];
      }
      return [];
    }
  },

  watch: {
    partitionComputed: {
      handler() {
        // console.log('监听分区变化', this.partitionId, this.subregionList);

        // 没有选择分区
        if (!this.partitionId) {
          this.defaultPartitionObj.default.arr = [];
          this.defaultPartitionObj.default.otherArr = otherArr;
          return;
        }

        // 选择了分区 但是分区暂时没有数据
        if (this.subregionList.length === 0) {
          return;
        }

        // 默认选中
        // this.partitionAffiliateId = this.subregionList[0].id;

        // 先将之前的数据清空
        for (const key in this.partitionObj) {
          this.$delete(this.partitionObj, key);
        }

        // 将分区数据赋值
        this.subregionList.map(item => item.id).forEach(item => {
          this.$set(this.partitionObj || {}, item, {
            arr: [],
            otherArr: otherArr
          });
        });
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    // 添加
    handleAdd() {
      // 没有选择分区
      if (!this.partitionId) {
        this.defaultPartitionObj.default.arr.push({
          ...TMP_OBJ
        });
        return;
      }

      // 选择了分区
      this.partitionObj[this.partitionAffiliateId].arr.push({ ...TMP_OBJ });
    },

    // 选择分区
    changePartition(arr = []) {
      if (arr.length === 0) { return; }
      this.partitionObj[this.partitionAffiliateId].arr = arr;
    },
    changePartitionOther(arr = []) {
      if (arr.length === 0) { return; }
      this.partitionObj[this.partitionAffiliateId].otherArr = arr;
    },

    /**
     * 提交校验
     *    1. 直接校验当前分区
     *    2. 其他分区填写的数据校验
     */
    async submitForm() {
      // 没有选择分区
      if (!this.partitionId) {
        // 没有添加分区
        if (this.defaultPartitionObj.default.arr.length === 0) {
          this.$message.error(this.$t('basicData.PleaseAddDetails'));
          return false;
        }

        //  直接调用子组件的方法检验
        const isBool = await this.$refs.defaultTableRef.submitForm();

        if (!isBool) {
          this.$message.warning(this.$t('operatingPlatform.PleaseFillInTheRequiredFields'));
          return false;
        }
        return true;
      }

      // 选择了分区
      // 校验是否添加了数据
      {
        const arr = []; // 二维数组
        for (const key in this.partitionObj) {
          if (this.partitionObj[key].arr.length > 0) {
            arr.push(this.partitionObj[key].arr);
          }
        }

        if (arr.length === 0) {
          this.$message.warning(this.$t('basicData.PleaseAddDetails'));
          return false;
        }
      }

      // 先校验当前选中的分区
      {
        const isBool = await this.$refs.tableRef.submitForm();
        if (!isBool) {
          this.$message.warning(this.$t('basicData.CheckFail'));
          return false;
        }
      }

      return true;
    },

    // 设置数据(主要是为父组件提供操作)
    async setData(arr) {
      if (arr.length === 0) { return; }
      console.log('setData', arr);
      const List = arr.filter(item => item.overSize === null && item.overWeight === null);
      const otherList = arr.filter(item => item.overSize !== null || item.overWeight !== null);
      console.log('otherList', otherList, arr, List);
      // 没有选择分区
      if (!this.partitionId) {
        this.defaultPartitionObj.default.arr = notSetPartitionFun(List, this.defaultPartitionObj.default.arr, 1);
        this.defaultPartitionObj.default.otherArr = notSetPartitionFun(otherList, this.defaultPartitionObj.default.otherArr, 2);
        console.log('notSetPartitionFun', this.defaultPartitionObj);

        return;
      }

      // 选择了分区
      console.log('分区数据', arr, this.partitionObj);
      const dataObj = cloneDeep(this.partitionObj);
      const row = await setPartitionFun(arr, dataObj);
      console.log(row, dataObj, this.partitionObj);
      for (const key in this.partitionObj) {
        console.log('分区数据', key, row[key]);
        this.partitionObj[key].arr = row[key] && row[key].arr ? row[key].arr : [];
        this.partitionObj[key].otherArr = row[key] && row[key].otherArr ? row[key].otherArr : otherArr;
      }
      console.log('分区', this.partitionObj);
    },

    /**
     * 获取数据
     * @returns {TTableRow[]}
     */
    getData() {
      /** @type {TTableRow[]} */
      const arr = [];

      // 没有选择分区
      if (!this.partitionId) {
        const list = this.defaultPartitionObj.default.arr.map(item => {
          return {
            ...item,
            partitionAffiliateId: undefined
          };
        });
        const otherList = this.defaultPartitionObj.default.otherArr.map(item => {
          return {
            ...item,
            partitionAffiliateId: undefined
          };
        });
        return [...list, ...otherList].filter(item => item.feeTypeCode);
      }

      // 选择了分区，将所有数据（二维数组）放入arr（一维数组）中
      Object.entries(this.partitionObj).filter(item => {
        const [, value] = item;
        return value.arr.length > 0;
      }).map(item => {
        console.log('提交分区数据', item);
        const [key, value] = item;
        const list = value.arr.map(item => {
          return {
            ...item,
            partitionAffiliateId: Number(key)
          };
        });
        const otherList = value.otherArr.map(item => {
          return {
            ...item,
            partitionAffiliateId: Number(key)
          };
        });
        console.log('分区数据', list, otherList, key);
        arr.push(...list);
        arr.push(...otherList);
      });
      return arr.filter(item => item.feeTypeCode);
    },

    // 下载报价回调函数
    onDownloadOffer() {
      /** @type {TTableRow[]} */
      const list = this.getData();
      // console.log(list);

      return list.map(item => {
        const { partitionAffiliateId } = item;

        const obj = {
          ...item
        };

        // 分区名称处理
        {
          const partitionAffiliateObj = this.subregionList.find(item => {
            return item.id === partitionAffiliateId;
          });
          // console.log('partitionAffiliateObj', partitionAffiliateObj);
          if (partitionAffiliateObj) {
            const { partitionIdentifier, id } = partitionAffiliateObj;
            obj.partitionAffiliateId = `${partitionIdentifier}${SEPARATOR}${id}`;
          }
        }
        return obj;
      });
    },

    /**
     * 导入数据
     * @param {TTableRow[]} arr 导入返回的数据
     */
    onImportList(arr) {
      console.log('importList', arr);

      // this.setData(arr);
      // 如果选择了分区，则需要校验所有分区存在数据
      if (this.partitionId) {
        const isBool = arr.every(item => {
          const { partitionAffiliateId } = item;
          return !!this.partitionObj[partitionAffiliateId];
        });

        if (!isBool) {
          const str1 = this.$t('operationCenter.DownloadTheTemplate'); // 下载模板
          const str2 = this.$t('GlobalSetObj.pleaseChoose'); // 请选择
          const str3 = this.$t('operationCenter.partition'); // 分区

          this.$message.warning(`${str1}${str2}${str3}`);
          return;
        }
      }
      this.setData(arr);
    },

    // 清空当前分区
    onClear() {
      // 没有选择分区
      if (!this.partitionId) {
        this.defaultPartitionObj.default.arr = [];
        this.defaultPartitionObj.default.otherArr = otherArr;
        return;
      }

      // 选择了分区
      this.partitionObj[this.partitionAffiliateId].arr = [];
      this.partitionObj[this.partitionAffiliateId].otherArr = otherArr;
    },

    // 清空所有报价
    onAllClear() {
      // 没有选择分区
      if (!this.partitionId) {
        this.defaultPartitionObj.default.arr = [];
        this.defaultPartitionObj.default.otherArr = otherArr;
        return;
      }

      // 选择了分区
      for (const key in this.partitionObj) {
        this.partitionObj[key].arr = [];
        this.partitionObj[key].otherArr = otherArr;
      }
    }
  }

};
</script>
